import initializeComponent from 'Shared/react-initialize';
import { ModerationDashboard } from './ModerationDashboard';

initializeComponent('Moderation', ModerationDashboard);
